import axios from "axios";
import store from "./store";
import router from "./router";
import $i18n from './i18n';
const i18n: any = $i18n.global;

var baseURLString: string;
if (window.location.origin.includes("localhost")) {
  baseURLString = process.env.VUE_APP_API_BASE_URL;
} else {
  baseURLString = window.location.origin + "/psc-backend/";
}
axios.defaults.withCredentials = true;

let webBaseUrl = process.env.VUE_APP_BASE_URL;

/**
 * Whenever app receives 401 response, it cleans userData, because we are already logged off on server
 * Whenever app receives 426 response, it reloads itself
 */

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && 401 === error.response.status) {
      store.commit("clearAllStoreData");
      router.push({ name: "landing" });
      store.commit("setErrorMessage", i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE"));
      return Promise.reject(error);
    } else if (error && error.response && 426 === error.response.status) {
      let reloadUrl = webBaseUrl + "?timestamp=" + Date.now().toString();
      window.location.replace(reloadUrl);
    } else {
      return Promise.reject(error);
    }
  }
);

export default {
  install: (app) => {
    app.config.globalProperties.$http = axios.create({
      baseURL: baseURLString,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },
};
